import { AmbientLight, Color, MathUtils, Scene, Vector3 } from "three";
import { CharcterOxxo } from "../objects/CharacterOxxo";
import { CameraController } from "../../componets3D/CameraController";
import { MouseEvents } from "../../componets3D/MouseEvents";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { ContainerCleaningThree, MapOxxoTopicThree, PlaneProductExpired, OutdoorOxxo, FastFoodUnclean } from "../objects/Topics";
import { CubeSelect } from "../objects/CubeSelect";


export class SceneTopicThree extends Scene {
	constructor(loadingManager, container, render, character = new CharcterOxxo(), enviro) {
		super();
		this.characterSelected = character;
		this.environment = enviro;
		this.camera = new CameraController();
		this.loadingManager = loadingManager;
		this.mouseEvents = new MouseEvents(container, render, this.camera, this);
		this.background = new Color(0x71BCFE)
		this.light()
		this.create();
		this.listeners()
		this.renderAnimations();

		this.selectSumActFourLimit = 0
		this.selectSumActFour = 0
		this.sectionGroupObjects = {
			floor: {
				id: "floor",
				objects: ["ManchasBlancas", "Maruchans"]
			},
			sausages: {
				id: "sausages",
				objects: ["ManchasKatsup"]
			},
			vegetables: {
				id: "vegetables",
				objects: ["ManchasCafe", "Pinzas"]
			},
		}
		this.selectAct4 = ""
	}

	create() {
		this.map = new MapOxxoTopicThree(this.loadingManager);
		this.add(this.map);
		this.add(this.characterSelected)

		this.containerCleaning = new ContainerCleaningThree(this.loadingManager)

		this.outdoorOxxo = new OutdoorOxxo(this.loadingManager)

		this.floorOut = new CubeSelect("floorExterior", 0xA5A5A5)
		this.floorOut.material.emissive.set("#404040")

		this.cubeCooler = new CubeSelect("cubeCooler", 0xffffff)
		this.islaCube = new CubeSelect("isla", 0xffffff)

		this.planeProductExpired = new PlaneProductExpired(this.loadingManager)

		this.fastFoodClean = new FastFoodUnclean(this.loadingManager)

	}

	light() {
		this.ambient = new AmbientLight();
		this.ambient.color.set(0xffffff);
		this.ambient.intensity = 1;
		this.add(this.ambient);
	}

	SceneInitialState() {

	}

	characterPositionOne() {
		this.characterSelected.position.set(-5.9111, -1.8, -4);
		this.characterSelected.rotation.set(0, 0.9998, 0);
		this.characterSelected.visible = true;
		this.characterSelected.onAnimateSaludo();
	}

	restoreActOne() {
		this.map.Puerta.material.opacity = 1
		this.map.Puerta_1.material.opacity = 1
	}

	sceneActivityOneState() {

		this.map.Puerta.material.opacity = 1
		this.map.Puerta_1.material.opacity = 1
		this.map.clearAnimation()

		this.characterPositionOne()

		this.mouseEvents.disposeInteractions()

		this.containerCleaning.position.set(-14.5842, -1.5118, -7.0663)
		this.containerCleaning.onInVisibleAll()
		this.add(this.containerCleaning)

		ObserverEmitter.on(EVENTS.tema3.topic3.actOne.actScene, (step = "") => {

			this.containerCleaning.onInVisibleAll()
			this.map.clearAnimation()
			switch (step) {
				case "iluminat_zone":
					this.map.onAnimateEmissiveMultiIntensity([this.map.Mostrador001, this.map.Mostrador])
					this.camera.moveCameraToPoint(new Vector3(-5.8469, 0.8213, -1.4922), 1, new Vector3(-8.48, 0.11, -2.587), () => {
						ObserverEmitter.emit(EVENTS.tema3.topic2.actOne.finishMoveAnimation, "iluminat_zone")
					})
					break;
				case "view_spray":
					this.containerCleaning.Trapo.visible = true
					this.containerCleaning.position.set(-7.9107, 0.4704, -2.1763)
					break;
				case "iluminate_koaxka":
					this.map.onAnimateEmissiveMultiIntensity([this.map.Refri_1001])
					this.camera.moveCameraToPoint(new Vector3(-4.9611, 0.7387, -4.2268), 1, new Vector3(-4.909, -0.132, -7.033), () => {
						ObserverEmitter.emit(EVENTS.tema3.topic2.actOne.finishMoveAnimation, "iluminate_koaxka")
					})

					break;

				case "view_box":
					this.camera.moveCameraToPoint(new Vector3(-7.3017, 0.0776, 8.144), 2, new Vector3(-4.484, -0.7, 8.451), () => {
						this.camera.moveCameraToPoint(new Vector3(4.8502, 0.6691, 10.368), 2, new Vector3(7.633, -0.266, 10.504), () => {

							this.map.onAnimationOpacity(this.map.Puerta, () => {
								this.camera.moveCameraToPoint(new Vector3(14.3733, 0.6053, 8.7292), 2, new Vector3(12.133, -0.504, 7.184), () => {
									ObserverEmitter.emit(EVENTS.tema3.topic2.actOne.finishMoveAnimation, "view_box")
								})
							})

						})
					})
					break;

				case "go_food_fast":
					this.map.onAnimateEmissiveMultiIntensity([this.map.Refri_1001])
					this.camera.moveCameraToPoint(new Vector3(14.4395, 0.351, 9.7197), 1, new Vector3(11.553, -0.194, 9.81), () => {
						this.camera.moveCameraToPoint(new Vector3(-6.9613, 1.0477, 7.9977), 2, new Vector3(-7.628, 0.253, 5.248), () => {
							this.camera.moveCameraToPoint(new Vector3(-4.7258, -0.3514, -6.3286), 1, new Vector3(-4.534, -0.675, -9.243), () => {
								this.containerCleaning.position.set(-4.823, -0.4118, -7.9107)
								this.containerCleaning.Salchichas.visible = true
								ObserverEmitter.emit(EVENTS.tema3.topic2.actOne.finishMoveAnimation, "go_food_fast")
							})
						})
					})
					break;

				case "go_bread":
					this.map.onAnimateEmissiveMultiIntensity([this.map.Mesh292])
					this.camera.moveCameraToPoint(new Vector3(-11.9225, -0.15, -7.0532), 1, new Vector3(-14.745, -0.97, -7.05), () => {
						ObserverEmitter.emit(EVENTS.tema3.topic2.actOne.finishMoveAnimation, "go_bread")
					})
					break;
				case "go_waste_bags":
					this.camera.moveCameraToPoint(new Vector3(4.8502, 0.6691, 10.368), 2, new Vector3(7.633, -0.266, 10.504), () => {

						this.camera.moveCameraToPoint(new Vector3(13.5991, 0.503, 9.4042), 2, new Vector3(13.522, -0.568, 6.668), () => {
							this.camera.moveCameraToPoint(new Vector3(15.0455, 0.4331, 0.577), 2, new Vector3(12.926, -0.813, 2.187), () => {
								ObserverEmitter.emit(EVENTS.tema3.topic2.actOne.finishMoveAnimation, "go_waste_bags")
							})
						})

					})
					break;

				case "go_room_cold":
					this.camera.moveCameraToPoint(new Vector3(14.3733, 0.6053, 8.7292), 2, new Vector3(12.133, -0.504, 7.184), () => {
						ObserverEmitter.emit(EVENTS.tema3.topic2.actOne.finishMoveAnimation, "go_room_cold")
					})
					break;

				case "go_desk":
					this.camera.moveCameraToPoint(new Vector3(14.4395, 0.351, 9.7197), 1, new Vector3(11.553, -0.194, 9.81), () => {
						this.camera.moveCameraToPoint(new Vector3(-6.9613, 1.0477, 7.9977), 2, new Vector3(-7.628, 0.253, 5.248), () => {

							this.map.onAnimateEmissiveMultiIntensity([this.map.Mostrador001, this.map.Mostrador])
							this.camera.moveCameraToPoint(new Vector3(-5.8469, 0.8213, -1.4922), 1, new Vector3(-8.48, 0.11, -2.587), () => {
								ObserverEmitter.emit(EVENTS.tema3.topic2.actOne.finishMoveAnimation, "go_desk")
							})

						})
					})
					break;

				case "ilumination_desk":
					break;

				case "sausages":
					this.camera.moveCameraToPoint(new Vector3(4.8502, 0.6691, 10.368), 2, new Vector3(7.633, -0.266, 10.504), () => {

						this.camera.moveCameraToPoint(new Vector3(13.5991, 0.503, 9.4042), 2, new Vector3(13.522, -0.568, 6.668), () => {
							this.camera.moveCameraToPoint(new Vector3(12.8044, 0.0099, 3.4687), 2, new Vector3(15.612, -0.858, 3.513), () => {
								ObserverEmitter.emit(EVENTS.tema3.topic2.actOne.finishMoveAnimation, "sausages")
							})
						})

					})

					break;

				case "rang":
					this.containerCleaning.position.set(15.4683, -0.8529, 3.5582)
					this.containerCleaning.Trapo.visible = true
					break;
				case "garbage_bag":
					this.camera.moveCameraToPoint(new Vector3(15.0455, 0.4331, 0.577), 2, new Vector3(12.926, -0.813, 2.187), () => {
						ObserverEmitter.emit(EVENTS.tema3.topic2.actOne.finishMoveAnimation, "garbage_bag")
					})
					break;

				case "go_back_init":
					this.camera.moveCameraToPoint(new Vector3(14.4395, 0.351, 9.7197), 1, new Vector3(11.553, -0.194, 9.81), () => {
						this.camera.moveCameraToPoint(new Vector3(-6.9613, 1.0477, 7.9977), 2, new Vector3(-7.628, 0.253, 5.248), () => {
							this.camera.moveCameraToPoint(new Vector3(-4.2751, -1.3041, -3.0297), 1, new Vector3(-6.81, -1.86, -4.409), () => {
								this.characterSelected.visible = true
								ObserverEmitter.emit(EVENTS.tema3.topic2.actOne.finishMoveAnimation, "go_back_init")
							})
						})
					})
					break;

				default:
					this.restoreActOne()
					break;
			}
		})
	}

	restoreActTwo() {
		this.outdoorOxxo.visible = false
		this.floorOut.visible = false
		this.cubeCooler.visible = false
		this.islaCube.visible = false
		this.map.clearAnimation()
		this.map.Puerta1.material.opacity = 1
		this.map.Puerta.material.opacity = 1
	}

	initTwo() {
		this.outdoorOxxo.visible = true
		this.floorOut.visible = true

		this.floorOut.clearAnimation()
		this.outdoorOxxo.clearAnimation()
		this.map.clearAnimation()
		this.cubeCooler.clearAnimation()
		this.islaCube.clearAnimation()

		this.map.Puerta1.material.opacity = 1
		this.map.Puerta.material.opacity = 1
	}

	sceneActivityTwoState() {
		this.characterSelected.position.set(-9.2194, -3.0347, 11.954);
		this.characterSelected.rotation.set(0, -0.8749, 0);
		this.characterSelected.visible = true;
		this.characterSelected.onAnimateSaludo();

		this.outdoorOxxo.position.set(-7.0285, -2.4911, 12.3805)
		this.outdoorOxxo.Bolsa_Basura.position.set(0.4558, -0.1449, 0)
		this.outdoorOxxo.Recogedor.position.set(-0.4265, 0.1879, 0)
		this.outdoorOxxo.Escoba.position.set(0.8969, 0, 0)
		this.add(this.outdoorOxxo)

		this.floorOut.scale.set(54.48, 0.45, 40.15)
		this.floorOut.position.y = -3.2636
		this.add(this.floorOut)

		this.cubeCooler.position.set(6.6607, -0.5107, -1.3457)
		this.cubeCooler.scale.set(0.45, 3.12, 5.41)
		this.cubeCooler.visible = false
		this.add(this.cubeCooler)

		this.islaCube.visible = false
		this.islaCube.position.set(-7.8633, -2.6027, 3.2486)
		this.islaCube.scale.set(1.55, 1.55, 1.55)
		this.add(this.islaCube)

		this.initTwo()
		this.mouseEvents.disposeInteractions()

		ObserverEmitter.on(EVENTS.tema3.topic3.actTwo.actScene, (step = "") => {
			this.mouseEvents.disposeInteractions();
			this.mouseEvents.objectsToValue = [];

			this.floorOut.clearAnimation()
			this.outdoorOxxo.clearAnimation()
			this.map.clearAnimation()
			this.cubeCooler.clearAnimation()
			this.islaCube.clearAnimation()

			this.cubeCooler.visible = false
			this.islaCube.visible = false
			switch (step) {
				case "click_panel_floor":
					this.camera.moveCameraToPoint(new Vector3(-8.8747, -0.5473, 18.6462), 1, new Vector3(-7.794, -0.982, 15.946), () => {
						this.floorOut.onAnimateEmissive()
						this.mouseEvents.objectsToValue = [this.floorOut];
					})
					break;
				case "click_panel_bag":
					this.outdoorOxxo.onAnimateMultipleEmissieve([this.outdoorOxxo.Bolsa_Basura, this.outdoorOxxo.Bote_Basura])
					this.mouseEvents.objectsToValue = [this.outdoorOxxo.Bolsa_Basura, this.outdoorOxxo.Bote_Basura];
					break;
				case "click_panel_Windows":
					this.map.onAnimateEmissiveMultiIntensity([this.map.Ventanas])
					this.mouseEvents.objectsToValue = [this.map.Ventanas];
					break;
				case "go_store":
					this.camera.moveCameraToPoint(new Vector3(-14.2419, -0.1176, 10.9591), 1, new Vector3(-12.192, -0.455, 8.878), () => {
						this.map.onAnimationOpacity(this.map.Puerta1, () => {
							this.camera.moveCameraToPoint(new Vector3(-11.1398, 1.2386, -1.0456), 1, new Vector3(-8.266, 0.665, -0.806), () => {
								this.camera.control.enableZoom = true;
								ObserverEmitter.emit(EVENTS.tema3.topic3.actTwo.finishActScene, "go_store")
							})
						})
					})
					break;

				case "view_cooler":
					this.cubeCooler.onAnimationOpacity()
					this.cubeCooler.visible = true
					this.mouseEvents.objectsToValue = [this.cubeCooler];
					break;

				case "view_floor":
					this.map.onAnimateEmissiveMultiIntensity([this.map.Piso])
					this.mouseEvents.objectsToValue = [this.map.Piso];
					break;

				case "view_clean":
					this.camera.moveCameraToPoint(new Vector3(-8.5293, 2.0511, -3.4535), 1, new Vector3(-8.266, 0.667, -0.806), () => {
						this.islaCube.visible = true
						this.islaCube.onAnimationOpacity()
						this.mouseEvents.objectsToValue = [this.islaCube];
					})
					break;

				case "view_bathroom":
					this.camera.moveCameraToPoint(new Vector3(4.8502, 0.6691, 10.368), 2, new Vector3(7.633, -0.266, 10.504), () => {

						this.map.onAnimationOpacity(this.map.Puerta, () => {

							this.camera.moveCameraToPoint(new Vector3(13.5991, 0.503, 9.4042), 2, new Vector3(13.522, -0.568, 6.668), () => {
								this.camera.moveCameraToPoint(new Vector3(14.0523, -0.062, 0.8014), 2, new Vector3(14.197, -0.843, -2.029), () => {
									this.map.onAnimateEmissiveMultiIntensity([this.map.Puerta001])
									this.mouseEvents.objectsToValue = [this.map.Puerta001];
								})
							})

						})

					})
					break;

				case "view_chemicals":
					this.camera.moveCameraToPoint(new Vector3(13.5939, 0.482, 3.7244), 2, new Vector3(16.384, -0.404, 3.471), () => {
						this.map.onAnimateEmissiveMultiIntensity([this.map.Cloro_1])
						this.mouseEvents.objectsToValue = [this.map.Cloro_1];
					})
					break;

				default:
					this.restoreActTwo()
					break;
			}

			this.mouseListeners();
		})

	}

	restoreActThree() {
		this.planeProductExpired.visible = false
		this.map.clearAnimationNames(this.map.productsRack.miniProducts)
	}

	sceneActivityThreeState() {
		this.characterPositionOne()

		this.characterSelected.rotation.y = 0.5587

		this.planeProductExpired.position.set(-5.2641, -1.4718, -3.9407)
		this.planeProductExpired.onInVisible()
		this.planeProductExpired.visible = true
		this.add(this.planeProductExpired)

		this.map.clearAnimationNames(this.map.productsRack.miniProducts)

		ObserverEmitter.on(EVENTS.tema3.topic3.actThree.actScene, (step = "") => {

			this.planeProductExpired.onInVisible()

			switch (step) {
				case "view_expiration":
					this.planeProductExpired.salchicasExpiradas.visible = true
					break;

				case "remove_products":
					this.camera.moveCameraToPoint(new Vector3(1.0402, 0.0179, -0.3118), 2, new Vector3(1.012, -1.083, -3.036), () => {
						this.map.onEmissiveMultipleName(this.map.productsRack.miniProducts)
						ObserverEmitter.emit(EVENTS.tema3.topic3.actThree.finishActScene, "remove_products")
					})
					break;

				case "accommodate_products":
					this.map.clearAnimationNames(this.map.productsRack.miniProducts)
					this.camera.moveCameraToPoint(new Vector3(-4.6962, -1.5072, -1.9068), 1, new Vector3(-5.92, -1.779, -4.565), () => {
						this.characterSelected.visible = true
						ObserverEmitter.emit(EVENTS.tema3.topic3.actThree.finishActScene, "accommodate_products")
					})
					break;

				case "remove_not_ticket":
					this.planeProductExpired.empaque.visible = true
					break;

				case "expired_sausage":
					this.planeProductExpired.salchichasCaducadas.visible = true
					break;

				case "expired_frut":
					this.planeProductExpired.tomate.visible = true
					break;

				case "expired_bread":
					this.planeProductExpired.Pan1.visible = true
					break;

				default:
					this.restoreActThree()
					break;
			}
		})

	}

	restoreActFour() {
		this.fastFoodClean.visible = false
		this.map.Fast_Food.visible = true
		this.fastFoodClean.clearAnimation()
	}

	initFour() {
		this.fastFoodClean.onInitActiv()
		this.selectSumActFourLimit = 0
		this.selectSumActFour = 0
		this.sectionGroupObjects = {
			floor: {
				id: "floor",
				objects: ["ManchasBlancas", "Maruchans"]
			},
			sausages: {
				id: "sausages",
				objects: ["ManchasKatsup"]
			},
			vegetables: {
				id: "vegetables",
				objects: ["ManchasCafe", "Pinzas"]
			},
		}
		this.selectAct4 = ""
	}

	sceneActivityFourState() {
		this.characterSelected.position.set(-3.0368, -0.0969, 1.3526);
		this.characterSelected.rotation.set(0, 3.8, 0);
		this.characterSelected.visible = true;
		this.characterSelected.onAnimateSaludo();

		this.map.Fast_Food.visible = false

		this.fastFoodClean.visible = true
		this.add(this.fastFoodClean)

		this.mouseEvents.disposeInteractions();

		this.mouseEvents.objectsToValue = [
			this.fastFoodClean.Manchas_Suelo_01,
			this.fastFoodClean.Maruchan_3001,
			this.fastFoodClean.Maruchan_3002,
			this.fastFoodClean.Maruchan_2001,
			this.fastFoodClean.Pinzas,
			this.fastFoodClean.Manchas_suelo_02,
			this.fastFoodClean.Gota_Cafe,
			this.fastFoodClean.Mancha_cafe,
			this.fastFoodClean.Manchas_Cafe_plancha,
			this.fastFoodClean.Manchas_Gabinete,
			this.fastFoodClean.Manchas_ketchup,
		];

		this.mouseListenersAct4()

		this.initFour()

		ObserverEmitter.on(EVENTS.tema3.topic3.actFour.actScene, (step = "") => {

			this.selectSumActFour = 0
			switch (step) {
				case "clean_floor":
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.moveCameraToPoint(new Vector3(-11.8668, -0.5105, -6.3302), 1, new Vector3(-11.682, -0.937, -7.3), () => {
						this.camera.control.enableZoom = true
						this.camera.control.enableRotate = true;
						this.camera.control.maxAzimuthAngle = 0.336;
						this.camera.control.minAzimuthAngle = -0.912;

						this.fastFoodClean.onAnimationSectionName(this.sectionGroupObjects.floor.id)
						this.selectAct4 = this.sectionGroupObjects.floor.id
						this.selectSumActFourLimit = this.sectionGroupObjects.floor.objects.length
					})
					break;

				case "clean_products":

					break;

				case "clean_sausages":
					this.fastFoodClean.onAnimationSectionName(this.sectionGroupObjects.sausages.id)
					this.selectAct4 = this.sectionGroupObjects.sausages.id
					this.selectSumActFourLimit = this.sectionGroupObjects.sausages.objects.length
					break;

				case "clean_vegetables":
					this.fastFoodClean.onAnimationSectionName(this.sectionGroupObjects.vegetables.id)
					this.selectAct4 = this.sectionGroupObjects.vegetables.id
					this.selectSumActFourLimit = this.sectionGroupObjects.vegetables.objects.length
					break;

				case "init_place":
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.moveCameraToPoint(new Vector3(-3.8976, 0.4193, 0.3447), 1, new Vector3(-1.976, -0.63, 2.306), () => {
						this.camera.control.enableRotate = false;
						this.camera.control.enablePan = false;
						this.camera.control.enableZoom = false

						this.characterSelected.visible = true
						this.characterSelected.onAnimationFestejo()
					});
					break;

				default:
					this.restoreActFour()
					break;
			}
		})

	}


	listeners() {

	}

	activeAudio() {
		ObserverEmitter.emit(EVENTS.audioInitByTopic)
	}

	ActivitiSelected(activity) {
		switch (activity) {
			case 0:
				this.camera.moveCameraToPoint(new Vector3(-12.4058, -0.5368, 4.338), 2, new Vector3(-11.992, -1.74, -9.102), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.control.minDistance = 13.5;
					this.camera.control.maxDistance = 13.5;
					this.camera.control.enablePan = false;

					this.activeAudio()

				})
				break;
			case 1:
				//* posicion panes
				this.camera.moveCameraToPoint(new Vector3(-4.2751, -1.3041, -3.0297), 1, new Vector3(-6.81, -1.86, -4.409), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.maxAzimuthAngle = 4;
					this.camera.control.minAzimuthAngle = -1.67;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enableRotate = false;
					this.camera.control.enablePan = false;
					this.camera.control.enableZoom = false

					this.activeAudio()

					this.sceneActivityOneState();
				});
				break;
			case 2:
				this.camera.moveCameraToPoint(new Vector3(-11.3932, -2.389, 14.342), 1, new Vector3(-9.211, -2.888, 12.435), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.maxAzimuthAngle = 2.122;
					this.camera.control.minAzimuthAngle = -3.537;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enableRotate = false;
					this.camera.control.enablePan = false;
					this.camera.control.enableZoom = false
					this.activeAudio()

					this.sceneActivityTwoState()
				});
				break;
			case 3:
				this.camera.moveCameraToPoint(new Vector3(-4.6962, -1.5072, -1.9068), 1, new Vector3(-5.92, -1.779, -4.565), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.maxAzimuthAngle = 2.122;
					this.camera.control.minAzimuthAngle = -3.537;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enableRotate = false;
					this.camera.control.enablePan = false;
					this.camera.control.enableZoom = false

					this.activeAudio()

					this.sceneActivityThreeState()
				});
				break;
			case 4:
				this.camera.moveCameraToPoint(new Vector3(-3.8976, 0.4193, 0.3447), 1, new Vector3(-1.976, -0.63, 2.306), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.maxAzimuthAngle = 2.122;
					this.camera.control.minAzimuthAngle = -3.537;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enableRotate = false;
					this.camera.control.enablePan = false;
					this.camera.control.enableZoom = false

					this.activeAudio()

					this.sceneActivityFourState()
				});
				break;
			default:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.ennablePan = false;

					this.characterSelected.visible = false

				});
				break;
		}
	}

	mouseListeners() {
		this.mouseEvents.onPointerUp((interactions) => {
			if (interactions[0]) {
				const name = interactions[0].object.name;
				const namesUi = {
					// * sub 3 act 2
					cubefloorExterior: "click_panel_floor",
					Bote_Basura: "click_panel_bag",
					Bolsa_Basura: "click_panel_bag",
					Ventanas: "click_panel_Windows",
					cubecubeCooler: "view_cooler",
					Piso: "view_floor",
					cubeisla: "view_clean",
					Puerta001: "view_bathroom",
					Cloro_1: "view_chemicals",
				}
				const nameSelect = namesUi[name]
				if (nameSelect) {
					ObserverEmitter.emit(EVENTS.tema3.topic3.actTwo.finishActScene, nameSelect)
				}
			}
		});
	}

	mouseListenersAct4() {
		this.mouseEvents.onPointerUp((interactions) => {
			if (interactions[0]) {
				const name = interactions[0].object.name;

				const getNameGroup = this.fastFoodClean.onDetectObjectGroup(name)
				const getIsObjects = this.sectionGroupObjects[this.selectAct4]

				if (!getIsObjects) {
					return
				}

				const { objects } = getIsObjects

				if (!objects.includes(getNameGroup)) {
					return
				}

				const getIsRayCaster = this.fastFoodClean.onDetectObject(name)

				if (!getIsRayCaster) {
					this.selectSumActFour++
				}

				if (this.selectSumActFour !== this.selectSumActFourLimit) {
					return
				}

				const namesUi = {
					floor: "clean_floor",
					sausages: "clean_sausages",
					vegetables: "clean_vegetables"
				}

				const nameSelect = namesUi[this.selectAct4]

				if (nameSelect) {
					ObserverEmitter.emit(EVENTS.tema3.topic3.actFour.finishActScene, nameSelect)
				}
			}
		});
	}

	renderAnimations(delta) {
	}
}
